import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import * as BiIcons from 'react-icons/bi';
import * as AiIcons from 'react-icons/ai';
import SafeIcon from './common/SafeIcon';
import './App.css';

const {FiHeart, FiLeaf, FiCheck, FiClock, FiUsers, FiStar, FiPlay, FiCalendar, FiVideo, FiArrowRight, FiPhone, FiMail, FiMapPin} = FiIcons;
const {BiLeaf} = BiIcons;
const {AiFillStar} = AiIcons;

function App() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 5,
    seconds: 0
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return { ...prev, seconds: prev.seconds - 1 };
        } else if (prev.minutes > 0) {
          return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
        } else if (prev.hours > 0) {
          return { ...prev, hours: prev.hours - 1, minutes: 59, seconds: 59 };
        } else if (prev.days > 0) {
          return { ...prev, days: prev.days - 1, hours: 23, minutes: 59, seconds: 59 };
        } else {
          // Reset to 5 minutes when timer reaches zero
          return { days: 0, hours: 0, minutes: 5, seconds: 0 };
        }
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleRegister = () => {
    window.open('https://abdul.cc/success', '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-teal-50">
      {/* Sticky Top Bar */}
      <div className="fixed top-0 left-0 right-0 bg-gradient-to-r from-emerald-600 to-teal-600 text-white py-2 px-4 z-50 shadow-lg">
        <div className="flex items-center justify-between max-w-6xl mx-auto">
          <div className="text-sm font-medium">
            <span className="hidden sm:inline">Live Tamil Class: </span>
            Become a 1 Lakh/month Healer
          </div>
          <button 
            onClick={handleRegister}
            className="bg-yellow-400 text-emerald-800 px-4 py-1 rounded-full text-sm font-semibold hover:bg-yellow-300 transition-colors"
          >
            Register Now – Limited Seats
          </button>
        </div>
      </div>

      {/* Hero Section */}
      <section className="pt-16 pb-12 px-4 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-emerald-100/50 to-teal-100/50"></div>
        <div className="relative max-w-6xl mx-auto">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <div className="inline-flex items-center bg-emerald-100 text-emerald-800 px-4 py-2 rounded-full mb-6 text-sm font-medium">
              <SafeIcon icon={FiVideo} className="mr-2" />
              Live Zoom Session • 100% தமிழ்
            </div>
            
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              1 Lakhs/Month Healer ஆக<br />
              <span className="text-emerald-600">எப்படி வரலாம்?</span><br />
              <span className="text-2xl sm:text-3xl lg:text-4xl text-gray-700">
                Hundreds of People's Health Reverse பண்ணி<br />
                You Can Earn with Purpose!
              </span>
            </h1>

            <p className="text-lg sm:text-xl text-gray-600 mb-8 max-w-4xl mx-auto leading-relaxed">
              நீங்க Healing கற்றுக்கிட்டு இருக்கிங்கனா… or Health Coachingல இருக்கீங்கனா…<br />
              <span className="font-semibold text-emerald-700">
                இந்த Live Tamil Class உங்களுக்கு எப்படி 1 Lakh/Month வருமானம் பண்ணலாம் என்று Step-by-Step காட்டும்.
              </span>
            </p>

            {/* Benefits Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8 max-w-4xl mx-auto">
              {[
                "Acupressure + Nature Cure use பண்ணி எப்படி real results கொடுக்கலாம்",
                "1:1 & Group Programs வைத்து predictable monthly income build பண்ணுவது",
                "WhatsApp & Zoom use பண்ணி clients எப்படி attract, serve & retain பண்ணுவது",
                "Busy life இருந்தாலும் consistent healer ஆக எப்படி glow ஆகலாம்"
              ].map((benefit, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.3 + index * 0.1 }}
                  className="flex items-start bg-white p-4 rounded-xl shadow-sm border border-emerald-100"
                >
                  <SafeIcon icon={FiCheck} className="text-emerald-500 mt-1 mr-3 flex-shrink-0" />
                  <span className="text-gray-700 text-left">{benefit}</span>
                </motion.div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="space-y-4 mb-6">
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={handleRegister}
                className="bg-gradient-to-r from-emerald-600 to-teal-600 text-white px-8 py-4 rounded-xl text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300 w-full sm:w-auto"
              >
                Yes, I Want to Become a 1 Lakh/Month Healer
                <SafeIcon icon={FiArrowRight} className="ml-2 inline" />
              </motion.button>
              
              <button 
                onClick={() => scrollToSection('learn')}
                className="block text-emerald-600 hover:text-emerald-700 transition-colors mx-auto"
              >
                See What You'll Learn in This Class ↓
              </button>
            </div>

            <p className="text-sm text-gray-500">
              Limited Seats • Live Q&A • Recording Bonus (conditions apply)
            </p>
          </motion.div>
        </div>
      </section>

      {/* Credibility Bar */}
      <section className="py-8 bg-white border-y border-gray-100">
        <div className="max-w-6xl mx-auto px-4">
          <p className="text-center text-gray-600 mb-6">
            Trusted by Classical Healing Members & Working Women who reversed PCOD, Hormonal Issues & Lifestyle Diseases.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            {[
              { text: "Real Case Studies", color: "bg-yellow-100 text-yellow-800" },
              { text: "Tamil Language", color: "bg-emerald-100 text-emerald-800" },
              { text: "No MLM, Only Pure Healing", color: "bg-blue-100 text-blue-800" },
              { text: "Beginner Friendly", color: "bg-purple-100 text-purple-800" }
            ].map((badge, index) => (
              <div key={index} className={`${badge.color} px-4 py-2 rounded-lg text-sm font-medium transform rotate-1 hover:rotate-0 transition-transform`}>
                {badge.text}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Target Audience */}
      <section className="py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            இந்த Class யாருக்காக?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="space-y-6">
              {[
                "Acupressure, Reiki, Pranic, Nature Cure, Yoga healers",
                "Housewives & Working Women who want to start Healing professionally",
                "Doctors, Therapists, Counsellors who want to add natural healing & coaching",
                "Anyone who loves helping people heal and wants ethical income through service"
              ].map((item, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="flex items-start"
                >
                  <SafeIcon icon={FiHeart} className="text-emerald-500 mt-1 mr-4 flex-shrink-0" />
                  <span className="text-gray-700">{item}</span>
                </motion.div>
              ))}
            </div>
            <div className="bg-gradient-to-br from-emerald-50 to-teal-50 p-8 rounded-2xl">
              <SafeIcon icon={FiLeaf} className="text-emerald-500 text-4xl mb-4" />
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                Special Note:
              </h3>
              <p className="text-gray-700 leading-relaxed">
                "Even if you are just learning now, this session will give you full clarity on your path. 
                நீங்க beginner ஆ இருந்தாலும், இந்த class உங்க journey-க்கு clear roadmap கொடுக்கும்."
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* What You Will Learn */}
      <section id="learn" className="py-16 px-4 bg-gradient-to-br from-gray-50 to-emerald-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            இந்த Live Classல என்ன கத்துக்கப் போறீங்க?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              {
                text: "1 Lakh/Month Healer Income Blueprint – numbersல எப்படி பொறுத்துவது",
                highlight: true,
                icon: FiStar
              },
              {
                text: "Healing Pathway: எப்படி diagnosis → protocol → follow-up structure பண்ணுவது",
                icon: FiHeart
              },
              {
                text: "Simple 3-Level Offer System (Free • Low Ticket • High Ticket) for Healers",
                highlight: true,
                icon: FiCheck
              },
              {
                text: "WhatsApp + Zoom + Simple Automation use பண்ணி எப்படி clients வர வைப்பது",
                icon: FiPhone
              },
              {
                text: "Real Case Studies: PCOD, Infertility, Migraine, Lifestyle disease reversal stories",
                highlight: true,
                icon: FiUsers
              },
              {
                text: "Ethical Selling: எப்படி sales சொல்லாமலேயே people ask 'When can we start?'",
                icon: FiArrowRight
              },
              {
                text: "How to protect your energy, avoid burnout & still serve hundreds of people",
                icon: FiLeaf
              },
              {
                text: "Complete Business Setup: Legal, Documentation, Payment systems எல்லாம்",
                icon: FiCheck
              }
            ].map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className={`p-6 rounded-xl ${
                  item.highlight 
                    ? 'bg-gradient-to-br from-yellow-100 to-orange-100 border-2 border-yellow-200 transform rotate-1 hover:rotate-0' 
                    : 'bg-white border border-gray-200'
                } transition-all duration-300 hover:shadow-lg`}
              >
                <div className="flex items-start">
                  <SafeIcon icon={item.icon} className={`mt-1 mr-4 flex-shrink-0 ${item.highlight ? 'text-orange-600' : 'text-emerald-500'}`} />
                  <span className="text-gray-700 leading-relaxed">{item.text}</span>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* About Trainer */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            உங்களை யார் guide பண்ணப் போறார்?
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="text-center lg:text-left">
              <div className="w-64 h-64 bg-gradient-to-br from-emerald-200 to-teal-200 rounded-full mx-auto lg:mx-0 mb-6 flex items-center justify-center">
                <SafeIcon icon={FiUsers} className="text-6xl text-emerald-600" />
              </div>
            </div>
            <div className="space-y-6">
              <h3 className="text-2xl font-bold text-gray-900">Abdul Hakkim A</h3>
              <div className="space-y-2 text-sm text-emerald-600">
                <p>• Acupressure Health Consultant</p>
                <p>• BNYS Student</p>
                <p>• Founder – Classical Healing Community & AIFunnels.app</p>
              </div>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  Born in poor family, struggled with health & money stress. 
                  Journey from engineer & digital marketer to Acupressure Health Consultant.
                </p>
                <p>
                  <strong>Authority:</strong> Helped many working women reverse PCOD, hormonal issues, 
                  and lifestyle diseases using naturopathy, acupressure, and Nature Cure lifestyle.
                </p>
                <p>
                  Founder of <strong>Classical Healing Community</strong> & trainer for healers & coaches 
                  who want to build ethical, profitable healing practices.
                </p>
              </div>
              <div className="flex flex-wrap gap-4">
                <div className="bg-emerald-100 text-emerald-800 px-4 py-2 rounded-lg text-sm font-medium">
                  500+ Students Trained
                </div>
                <div className="bg-teal-100 text-teal-800 px-4 py-2 rounded-lg text-sm font-medium">
                  5+ Years Experience
                </div>
                <div className="bg-blue-100 text-blue-800 px-4 py-2 rounded-lg text-sm font-medium">
                  100+ Success Stories
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Session Agenda */}
      <section className="py-16 px-4 bg-gradient-to-br from-emerald-50 to-teal-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Session Flow – என்னஎன்ன நடக்கப் போகுது?
          </h2>
          <div className="space-y-6">
            {[
              "Why Most Healers Struggle Financially (mindset & system mistakes)",
              "1 Lakh/Month Healer Framework – C.A.S.H style overview",
              "Healing Model: Consultations, Programs, Follow-up Systems",
              "Marketing for Healers (without becoming 'salesy' or fake)",
              "Q&A – உங்க doubts எல்லாம் clear பண்ணிக் கொள்ளலாம்",
              "Next Steps – எப்படி நீங்க உங்கள் journey தொடங்கலாம்"
            ].map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
                className="flex items-center bg-white p-6 rounded-xl shadow-sm border border-emerald-100"
              >
                <div className="w-8 h-8 bg-emerald-600 text-white rounded-full flex items-center justify-center font-semibold mr-4 flex-shrink-0">
                  {index + 1}
                </div>
                <span className="text-gray-700">{item}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Bonuses */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Special Bonuses for Live Attendees Only
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              {
                title: "Bonus #1",
                subtitle: "Healer Income Planner (PDF)",
                color: "bg-yellow-100 border-yellow-200 text-yellow-800"
              },
              {
                title: "Bonus #2", 
                subtitle: "7-Day 'First 10 Clients' WhatsApp Script Templates",
                color: "bg-emerald-100 border-emerald-200 text-emerald-800"
              },
              {
                title: "Bonus #3",
                subtitle: "Basic Healing Business Checklist",
                color: "bg-purple-100 border-purple-200 text-purple-800"
              }
            ].map((bonus, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className={`p-6 rounded-xl border-2 ${bonus.color} transform rotate-2 hover:rotate-0 transition-transform`}
              >
                <h3 className="font-bold text-lg mb-2">{bonus.title}</h3>
                <p className="text-sm">{bonus.subtitle}</p>
              </motion.div>
            ))}
          </div>
          <p className="text-center text-gray-600 mt-8">
            Bonuses only for those who register & attend live.
          </p>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 px-4 bg-gradient-to-br from-gray-50 to-emerald-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Real People, Real Healing Results
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              {
                name: "Priya R.",
                role: "Working Mom, Chennai",
                text: "PCOD problem 6 monthsல completely reverse ஆச்சு. இப்போ நானும் part-time healing practice start பண்ணிருக்கேன்!"
              },
              {
                name: "Kavitha S.",
                role: "Housewife, Coimbatore", 
                text: "Migraine pain 10 yearsல இருந்துது. Abdul sir oda guidance-ல 3 monthsல 90% relief கிடைச்சுது. Amazing!"
              },
              {
                name: "Rajesh M.",
                role: "IT Professional, Bangalore",
                text: "Wife-க்கு infertility issue. Classical healing approach use பண்ணி 8 monthsல conception ஆச்சு. Very grateful!"
              }
            ].map((testimonial, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-white p-6 rounded-xl shadow-lg border border-gray-100"
              >
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-emerald-200 rounded-full flex items-center justify-center mr-4">
                    <SafeIcon icon={FiUsers} className="text-emerald-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">{testimonial.name}</h3>
                    <p className="text-sm text-gray-600">{testimonial.role}</p>
                  </div>
                </div>
                <p className="text-gray-700 italic">"{testimonial.text}"</p>
                <div className="flex mt-4">
                  {[1,2,3,4,5].map(star => (
                    <SafeIcon key={star} icon={AiFillStar} className="text-yellow-400" />
                  ))}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Investment & Urgency */}
      <section id="register" className="py-16 px-4 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">
            இது உங்களுக்கு எவ்வளவு value தருது?
          </h2>
          
          <div className="bg-gradient-to-br from-emerald-50 to-teal-50 p-8 rounded-2xl mb-8">
            <div className="text-4xl font-bold text-emerald-600 mb-4">
              Ticket Price: <span className="text-red-500 line-through">₹2,997</span> 
              <span className="text-green-600"> FREE</span>
            </div>
            <p className="text-lg text-gray-700 mb-6">
              Limited Time for Classical Healing Members & Guests
            </p>
            
            {/* Countdown Timer */}
            <div className="bg-white p-6 rounded-xl shadow-lg mb-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Registration Closes In:</h3>
              <div className="grid grid-cols-4 gap-4">
                {[
                  { label: 'Days', value: timeLeft.days },
                  { label: 'Hours', value: timeLeft.hours },
                  { label: 'Minutes', value: timeLeft.minutes },
                  { label: 'Seconds', value: timeLeft.seconds }
                ].map((item, index) => (
                  <div key={index} className="text-center">
                    <div className="bg-emerald-600 text-white text-2xl font-bold p-4 rounded-lg">
                      {item.value.toString().padStart(2, '0')}
                    </div>
                    <div className="text-sm text-gray-600 mt-2">{item.label}</div>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="bg-red-100 border-2 border-red-200 text-red-800 px-4 py-3 rounded-lg transform -rotate-2">
              Only 50 Seats • Zoom room capacity limited
            </div>
          </div>

          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={handleRegister}
            className="bg-gradient-to-r from-emerald-600 to-teal-600 text-white px-12 py-4 rounded-xl text-xl font-bold shadow-xl hover:shadow-2xl transition-all duration-300 w-full sm:w-auto"
          >
            Secure My FREE Seat Now
            <SafeIcon icon={FiArrowRight} className="ml-2 inline" />
          </motion.button>
          
          <p className="text-sm text-gray-500 mt-4">
            Instant WhatsApp confirmation • Zoom link sent immediately
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-4 bg-gradient-to-br from-gray-50 to-emerald-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          <div className="space-y-6">
            {[
              {
                q: "I am a beginner. Can I attend?",
                a: "Absolutely! இந்த class beginners-க்கும் experienced healers-க்கும் value கொடுக்கும். நீங்க எந்த level-ல இருந்தாலும் clear roadmap கிடைக்கும்."
              },
              {
                q: "Will there be a recording?", 
                a: "Recording bonus கிடைக்கும், but only for live attendees. Full value கிடைக்க live-ல attend பண்ணுங்க for Q&A session."
              },
              {
                q: "Is this medical advice?",
                a: "No, this is educational content only. நாங்க medical advice கொடுக்கல. Always consult qualified doctors for medical conditions."
              },
              {
                q: "Can non-Classical Healing members join?",
                a: "Yes! இந்த session open for everyone who wants to learn ethical healing business. Members-க்கு priority, but guests welcome."
              },
              {
                q: "What tools do I need?",
                a: "Just mobile + WhatsApp + Zoom app. Nothing else needed. Simple setup for maximum learning."
              },
              {
                q: "Is it only for Tamil people?",
                a: "Main language Tamil தான். But simple English mix பண்ணுவோம் where needed. Tamil comfortable ஆ இருந்தா perfect!"
              },
              {
                q: "What if I miss the live session?",
                a: "Recording கிடைக்கும், but live Q&A miss ஆகும். Real doubts clear பண்ண live-ல இருக்கிறது best."
              },
              {
                q: "Any hidden costs later?",
                a: "This session is completely FREE. Later programs optional. No pressure, only value-based offerings if interested."
              }
            ].map((faq, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05 }}
                className="bg-white p-6 rounded-xl shadow-sm border border-gray-100"
              >
                <h3 className="font-semibold text-gray-900 mb-3">{faq.q}</h3>
                <p className="text-gray-700">{faq.a}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 px-4 bg-gradient-to-br from-emerald-600 to-teal-600 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6">
            Ready to Start Your 1 Lakh/Month Healer Journey?
          </h2>
          <p className="text-xl mb-8 leading-relaxed">
            ஒரு நல்ல Healer ஆகி, நூற்றுக்கணக்கான பேரோட வாழ்க்கையை மாற்றனும்னா…<br />
            <span className="font-semibold">இந்த one decision உங்க future-ஐ மாற்றும்.</span>
          </p>
          
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={handleRegister}
            className="bg-yellow-400 text-emerald-800 px-12 py-4 rounded-xl text-xl font-bold shadow-xl hover:shadow-2xl transition-all duration-300 w-full sm:w-auto"
          >
            Yes, Save My Seat Now
            <SafeIcon icon={FiArrowRight} className="ml-2 inline" />
          </motion.button>
          
          <p className="text-emerald-100 mt-4 text-sm">
            Instant WhatsApp confirmation • Zoom link sent immediately
          </p>
        </div>
      </section>

      {/* Sticky Bottom CTA - Mobile Only */}
      <div className="fixed bottom-0 left-0 right-0 bg-gradient-to-r from-emerald-600 to-teal-600 text-white p-4 z-50 shadow-lg sm:hidden">
        <div className="flex items-center justify-between">
          <div className="text-sm">
            <div className="font-semibold">Join the Live Zoom Class</div>
            <div className="text-emerald-100 text-xs">Limited Seats Available</div>
          </div>
          <button 
            onClick={handleRegister}
            className="bg-yellow-400 text-emerald-800 px-6 py-2 rounded-lg font-semibold hover:bg-yellow-300 transition-colors"
          >
            Book My Seat
          </button>
        </div>
      </div>

      {/* Add bottom padding for mobile sticky bar */}
      <div className="h-20 sm:h-0"></div>
    </div>
  );
}

export default App;